<script lang="ts" setup>
  import type { TrendingRoutesBlockStoryblok } from '@/storyblok/component-types-sb'
  import { AVAILABLE_ROUTES_LOCALES } from '@/utils/constants/trending-routes'

  const { locale } = useI18n()
  const excludedDestinationCode = inject<string>('destinCode', '')

  defineProps<{
    blok: TrendingRoutesBlockStoryblok
  }>()

  const canLoadTrendingRoutes = computed(() => AVAILABLE_ROUTES_LOCALES.includes(locale.value))
</script>

<template>
  <TrendingRoutes
    v-if="canLoadTrendingRoutes"
    :title="blok.title"
    :excluded-destination-code="excludedDestinationCode"
  />
</template>
